import React, { useEffect, useState } from "react";
import MHeader from "components/MHeader";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import StaticBar from "../StaticBar";
import { Button } from "antd";
import AnswerCardDrawer from "./component/AnswerCardDrawer";
import {
    ExerciseProps,
    PaperProps,
    TopicsItem
} from "../../../../../API/exercise";

import PageRadioDetail from "./component/PageRadioDetail";
import className from "classnames";
import PageCheckBoxDetail from "./component/PageCheckBoxDetail";
import PageJudgeDetail from "./component/PageJudgeDetail";
import PageSubjectiveDetail from "./component/PageSubjectiveDetail";
import PageGapFillingDetail from "./component/PageGapFillingDetail";
import PageReadingDetail from "./component/PageReadingDetail";

interface DetailMobileProps {
    data: PaperProps;
    headerData: ExerciseProps;
}

export default function ExerciseDetailMobile({
    data,
    headerData
}: DetailMobileProps) {
    const history = useHistory();
    const [showExerciseBar, setShowExerciseBar] = useState(false);
    const [checked, setChecked] = useState(1); //当前选中
    const [currentData, setCurrentData] = useState<TopicsItem>(); //选中的试题对象

    useEffect(() => {
        if (data) {
            setCurrentData(
                data.topics.find((item, index) => index + 1 === checked)
            );
        }
    }, [data, checked]);

    return (
        <div className={style.root}>
            <MHeader title="练习详情" goBack={history.goBack} />

            <div className={style.header}>
                <StaticBar
                    topicCount={data.topicCount}
                    totalScore={data.totalScore}
                    teacherFinishMark={data.teacherFinishMark}
                    viewPaper={data.viewPaper}
                    stuDoFlg={data.stuDoFlg}
                    stuPaperScore={data.stuPaperScore}
                />
                <Button
                    type="primary"
                    ghost
                    className={style.btnAnswerCard}
                    onClick={() => setShowExerciseBar(true)}>
                    答题卡
                </Button>
            </div>
            {/*选项卡*/}
            <AnswerCardDrawer
                visible={showExerciseBar}
                onClose={() => setShowExerciseBar(false)}
                checked={checked}
                data={data.topics}
                onChange={(val: number) => setChecked(val)}
            />

            <div className={style.body}>
                {currentData &&
                    currentData.queTypeId == "1" &&
                    checked === currentData.index && (
                        <PageRadioDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "2" &&
                    checked === currentData.index && (
                        <PageCheckBoxDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "3" &&
                    checked === currentData.index && (
                        <PageJudgeDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "4" &&
                    checked === currentData.index && (
                        <PageSubjectiveDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                            viewPaper={data.viewPaper}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId == "5" &&
                    checked === currentData.index && (
                        <PageGapFillingDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                        />
                    )}
                {currentData &&
                    currentData.queTypeId >= "6" &&
                    checked === currentData.index && (
                        <PageReadingDetail
                            stuDoFlg={data.stuDoFlg}
                            data={currentData}
                            viewPaper={data.viewPaper}
                        />
                    )}
            </div>

            <div className={style.footer}>
                <div className={style.postionRel}>
                    <div className={style.footerDiv}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={className(style.prev, {
                                    [style.one]: false
                                })}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={className(style.next, {
                                        [style.one]: false
                                    })}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
}
